import { render, staticRenderFns } from "./DutyTypeEdit.vue?vue&type=template&id=578eb0e1"
import script from "./DutyTypeEdit.vue?vue&type=script&lang=js"
export * from "./DutyTypeEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports